/* eslint-disable react/prop-types */
import React, { useEffect } from "react";
import { Box, Select } from "@mantine/core";
import { useQuery } from "@tanstack/react-query";
import { getSelectOptionsByTableName } from "../../../services/common.service";

const SelectWithAPI = ({
  placeholder,
  label,
  value,
  itemData,
  setValue,
  isRequired,
  onItemSelect,
  tableName,
  ...props
}) => {
  const [search, setSearch] = React.useState({
    enabled: true,
    text: "",
  });
  const getNestedValue = (obj, path) => {
    if (!obj || !path) return undefined;
    return path.split(".").reduce((acc, key) => acc?.[key], obj);
  };

  useEffect(() => {
    if (value === null || value === "" || value === undefined) {
      setSearch({ enabled: false, text: "" });
    }
  }, [value]);

  const dataQuery = useQuery({
    enabled: search?.enabled,
    queryKey: [`data-select`, tableName, search?.text, itemData?.filters],
    queryFn: () =>
      getSelectOptionsByTableName({
        tableName,
        filters: itemData?.filters
          ? itemData?.filters
          : `{"is_active_eq":true}`,
        page: -1,
        search: search?.text,
      }),
    select: (data) => {
      return data?.map((items) => {
        const displayOptions = JSON.parse(itemData?.display_options || "[]");

        const label = displayOptions
          .map((option) => getNestedValue(items, option))
          .filter(Boolean)
          .join(" - ")
          .toUpperCase();

        const value = Array.isArray(itemData?.return_value)
          ? itemData.return_value
            .map((key) => getNestedValue(items, key))
            .join(" - ")
          : getNestedValue(items, itemData?.return_value);

        return {
          ...items,
          label,
          value,
        };
      });
    },
  });

  return (
    <Box>
      <Select
        data={
          dataQuery?.data?.map((item) => ({
            ...item,
            value: item?.value?.toString(),
          })) || []
        }
        placeholder={placeholder}
        value={value?.toString()}
        onChange={(e) => {
           if (e === null) {
            setValue(null);
            setSearch({ enabled: true, text: "" });
          } else {
            setValue(e);
            setSearch({ enabled: false, text: "" });
          }
          const selectedItem = dataQuery?.data?.find(
            (item) => item.value?.toString() === e
          );
          if (onItemSelect) onItemSelect(selectedItem);
        }}
        withAsterisk={isRequired}
        searchable
        searchValue={search?.text}
        clearable
        onSearchChange={(e) => {
          setSearch({
            enabled: true,
            text: e,
          });
        }}
        label={label}
        // styles={{
        //   root: { position: 'relative' },
        //   label: {
        //     top: '12px',
        //     position: 'relative',
        //     left: '10px',
        //     backgroundColor: 'white',
        //     padding: '0px 6px',
        //     lineHeight: '12px',
        //     zIndex: '99',
        //     color: COLORS.textColor.label,
        //     fontSize: '12px'
        //   }
        // }}
        {...props}
      />
    </Box>
  );
};

export default SelectWithAPI;
